import React, { Fragment, Component } from 'react';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import { MdKeyboardArrowDown as DownArrow } from 'react-icons/md';
import { MdKeyboardArrowUp as UpArrow } from 'react-icons/md';
import defaultRowRenderer from 'components/shared/ReactVirtualizedTable/DefaultRowRenderer';
import ReactVirtualizedTable from 'components/shared/ReactVirtualizedTable';
import { Column } from 'react-virtualized';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
  },
};

class AvgSatisfactionTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
    };
  }

  getTableData = () => {
    const { graphData, level } = this.props;
    return graphData[level].children.map((child) => {
      return {
        name: child.insight_type_name,
        avg_satisfaction:
          parseInt(child['tickets_satisfaction_rate'], 10) === 0
            ? ''
            : child['tickets_satisfaction_rate'],
        insight_id: child['insight_id'],
      };
    });
  };

  showHide = () => {
    this.setState((prevState) => ({ hidden: !prevState.hidden }));
  };

  render() {
    const { graphData, level } = this.props;
    const { hidden } = this.state;
    if (!graphData[level].children) return null;
    if (graphData[level].childen && graphData[level].childen.length === 0) return null;

    return (
      <div className="col-sm-6">
        <div className="row">
          <h3 style={{ padding: '0 15px', marginBottom: '20px' }}>
            <button
              type="button"
              className="link-button"
              onClick={this.showHide}
              style={{ color: 'inherit' }}
            >
              Average Satisfaction
              <span>
                {hidden && <UpArrow size={24} />}
                {!hidden && <DownArrow size={24} />}
              </span>
            </button>
          </h3>
        </div>
        {this._renderTable()}
      </div>
    );
  }

  _renderTable = () => {
    if (this.state.hidden) return null;
    const { onClick, graphData, level } = this.props;
    return (
      <div className="row" style={{ padding: '0' }}>
        <Card style={style.transactionCard}>
          <CardText expandable={true} style={{ padding: '0', height: '300px' }}>
            <Fragment>
              <ReactVirtualizedTable
                data={this.getTableData()}
                rowRenderer={defaultRowRenderer}
                onRowClick={({ rowData }) => onClick(rowData.insight_id, 'category')}
              >
                <Column width={200} label={graphData[level].child_type} dataKey="name" />
                <Column width={200} label="Average Satisfaction" dataKey="avg_satisfaction" />
              </ReactVirtualizedTable>
            </Fragment>
          </CardText>
        </Card>
      </div>
    );
  };
}

export default AvgSatisfactionTable;
